module.exports = __webpack_public_path__ + "static/dakkapel-1-202787922426f41eb17cfdac394aa302.jpg";